export const APP_STORAGE_PREFIX = '[bridgerpay]';

export const INTERNAL_CONTROL_ERROR_STUB = 'internalControlErrorStub';

export const MODAL_OUTLET = 'modal';

export const MAT_DRAWER_ANIMATION_DURATION = 400;
